export const ContentEventNames = {
    started: "Video Content Started",
    playing: "Video Content Playing",
    completed: "Video Content Completed",
};
//# sourceMappingURL=ContentEvents.js.map